import React from "react";
import { useTranslation } from "react-i18next";
import favIco from "../../assets/img/fav_icon.png";
import { sanitizeHtml } from "../../shared/helpers/sanitizeHtml";
import { formatArticleDate } from "../blogs/articleHelpers";
import EditorialBadge from "../content/EditorialBadge";
import "../content/content.css";

/**
 * The answer to an editorial FAQ: signed by the AvoConsulte editorial team,
 * never by a lawyer (no name, photo or profile link, whatever the data
 * holds). Its HTML comes from seeds/editorial-faq and is sanitised anyway.
 */
export default function EditorialAnswer({ answer, lang }) {
  const { t } = useTranslation();
  const html = sanitizeHtml(answer.answer || "");
  // The loader appends a disclaimer to every answer; show ours if it is missing.
  const hasDisclaimer = /avc-article-note/.test(answer.answer || "");
  return (
    <section className="avc-editorial-answer" id="answer-1" lang={lang}>
      <div className="avc-editorial-answer__head">
        <span className="avc-editorial-answer__mark" aria-hidden="true">
          <img src={favIco} alt="" width="26" height="26" />
        </span>
        <div className="avc-editorial-answer__who">
          <span className="avc-editorial-answer__team">{t("faq_editorial_team")}</span>
          <span>
            <EditorialBadge compact />
          </span>
        </div>
        {answer.createdAt && (
          <time className="avc-question__date avc-editorial-answer__date" dateTime={answer.createdAt}>
            {formatArticleDate(answer.createdAt, lang)}
          </time>
        )}
      </div>
      <div className="avc-editorial-answer__content" dir="auto" dangerouslySetInnerHTML={{ __html: html }} />
      {!hasDisclaimer && <p className="avc-editorial-answer__note">{t("faq_editorial_note")}</p>}
    </section>
  );
}
